import { statusActions } from "./status-slice";
import { uiActions } from "../ui-slice";

export const GetStatuses = (email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Cargando información",
        message: "Se esta solicitando la información al servidor.",
      })
    );
    const GetStatusesInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/status/getall`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la información solicitada");
      }
      const data = await response.json();
      return data;
    };

    try {
      const response = await GetStatusesInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          statusActions.setStatuses({
            statuses: response.data.map((status) => {
              return {
                ...status,
                status: status.status === true ? "Activo" : "Inactivo",
              };
            }),
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          statusActions.setStatuses({
            statues: [],
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la información solicitada",
        })
      );
    }
  };
};
export const GetStatusInfo = (id, email) => {
  return async (dispatch) => {
    
    const getStatusInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/status/getById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el estado");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getStatusInfo();
      return response.data;
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el estado",
        })
      );
    }
  };
};
export const GetStatus = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando estado",
        message: "Solicitando estado al servidor.",
      })
    );
    const getStatusInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/status/getById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el estado");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getStatusInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          statusActions.setStatus({
            status: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          statusActions.setStatus({
            status: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el estado",
        })
      );
    }
  };
};

export const UpdateStatus = (status, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando estado",
        message: "Solicitando Actualización del estado al servidor.",
      })
    );
    const updateStatusInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/status/update`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: status.id,
            Name: status.name,
            Description: status.description,
            Color: status.color
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar el estado");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updateStatusInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          statusActions.setStatus({
            status: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Estado Actualizado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          statusActions.setStatus({
            status: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar el estado",
        })
      );
    }
  };
};
export const CreateStatus = (status, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando estado",
        message: "Solicitando Creación del estado al servidor.",
      })
    );
    const createStatusInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/status/create`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Name: status.name,
            Description: status.description,
            Color: status.color
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear el estado");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createStatusInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          statusActions.setStatus({
            status: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Estado Creado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          statusActions.setStatus({
            status: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear el estado",
        })
      );
    }
  };
};
export const ActiveStatus = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Activando estado",
        message: "Solicitando activación del estado al servidor.",
      })
    );
    const activeStatusInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/status/active`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo activar el estado");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await activeStatusInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          statusActions.setStatus({
            status: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Estado Activado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          statusActions.setStatus({
            status: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo activar el estado",
        })
      );
    }
  };
};
export const InactiveStatus = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Inactivando estado",
        message: "Solicitando activación del estado al servidor.",
      })
    );
    const inactiveStatusInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/status/inactive`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo inactivar el estado");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await inactiveStatusInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          statusActions.setStatus({
            status: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Estado Inactivado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          statusActions.setStatus({
            status: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo inactivar el estado",
        })
      );
    }
  };
};
